import { Container, Sprite, type Texture } from 'pixi.js';
import type { Trap } from '@/dungeon/traps';
import { TILE_SIZE } from '@/sprites/tiles';
import type { TrapSpriteKey } from '@/sprites/traps';

/**
 * Traps on the floor.
 *
 * Drawn under everything that moves, so a sprung trap does not sit on top of
 * the person who sprang it. Pooled and culled like every other renderer here.
 */
export class TrapRenderer {
  readonly container = new Container();
  private readonly pool: Sprite[] = [];

  constructor(private readonly textures: Readonly<Record<TrapSpriteKey, Texture>>) {}

  render(traps: readonly Trap[]): void {
    let used = 0;

    for (const trap of traps) {
      const sprite = this.spriteAt(used++);
      const state = trap.cooldown > 0 ? 'sprung' : 'armed';
      sprite.texture = this.textures[`${trap.definition.id}-${state}`];
      sprite.position.set(trap.x * TILE_SIZE, trap.y * TILE_SIZE);
      sprite.visible = true;
    }

    for (let i = used; i < this.pool.length; i++) this.pool[i]!.visible = false;
  }

  private spriteAt(index: number): Sprite {
    let sprite = this.pool[index];
    if (!sprite) {
      sprite = new Sprite();
      this.pool.push(sprite);
      this.container.addChild(sprite);
    }
    return sprite;
  }

  destroy(): void {
    this.container.destroy({ children: true });
  }
}
